<script>
import ConfirmAccountForm from "@/components/auth/ConfirmAccountForm.vue";
export default {
  components: { ConfirmAccountForm },
  name: "Confirm",
};
</script>

<template>
  <ConfirmAccountForm />
</template>

<style></style>
